import { ApplicationElement, html } from '@beunity/lit-components';

import '@beunity/lit-components/components/icon/element.js';
import '@beunity/lit-components/components/date_widget/element.js';
import '@beunity/lit-components/components/time_range/element.js';

/**
 * A list item for listing events. Contains a link, time interval and an optional image
 *
 * @prop href - Url to which this item should link (string)
 * @prop name - Title of this item (string)
 * @prop picture - Url of the photo to be shown in the list item (string, optional)
 * @prop startDate - Start datetime of the event shown in the list item (string)
 * @prop endDate - End datetime of the event shown in the list item (string)
 */
export default class ListItem7 extends ApplicationElement {
  createRenderRoot() {
    return this;
  }

  static properties = {
    href: { type: String },
    name: { type: String },
    picture: { type: String },
    startDate: { type: String },
    endDate: { type: String },
  };

  renderPicture() {
    return html`
      <img src="${this.picture}" class="img"></img>
    `;
  }

  renderPlaceholder() {
    return html` <ef-icon name="image"></ef-icon> `;
  }

  render() {
    return html`
      <a href="${this.href}">
        <ef-date-widget date=${this.startDate}></ef-date-widget>
        <div class="content">
          ${this.picture ? this.renderPicture() : this.renderPlaceholder()}
          <div class="info">
            <h4 class="title">${this.name}</h4>
            <ef-time-range
              from="${this.startDate}"
              to="${this.endDate}"></ef-time-range>
          </div>
        </div>
      </a>
    `;
  }
}

customElements.get('bu-list-item-7') ||
  customElements.define('bu-list-item-7', ListItem7);
